module.exports = __webpack_public_path__ + "img/news-feed-eng.4e300e9e.png";